<template>
  <div>
    <v-row class="mt-1" no-gutters>
      <v-col
        cols="12"
        xl="10"
        md="9"
        sm="12"
        order="first"
        style="cursor: pointer;"
        @click="() => showImg(-1)"
        v-if="listimg.length !== 0 && !loading"
      >
        <v-img
          :src="`${domoapi2_img}Articulo/${imagesPrincipal[0].codigo}/Galeria?archivo=${imagesPrincipal[0].archivo}&Cia=15`"
          :lazy-src="`${domoapi2_img}Articulo/${imagesPrincipal[0].codigo}/Galeria?archivo=${imagesPrincipal[0].archivo}&Cia=15`"
          aspect-ratio="1"
          max-width="480"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="secondary"
                size="30"
                width="2"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        order="first"
        @click="() => showImg(0)"
        v-if="listimg.length === 0 && !loading"
      >
        <v-img
          :src="`${domoapi2_img}Articulo/${codart}/Principal?Cia=15`"
          :lazy-src="`${domoapi2_img}Articulo/${codart}/Principal?Cia=15`"
          aspect-ratio="1"
          max-width="480"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-col>
      <v-col
        cols="12"
        xl="2"
        md="3"
        sm="6"
        v-if="listimg !== null && !loading"
        class="scrollable"
      >
        <v-row no-gutters >
          <v-col
            v-for="(item, n) in imagesLateral"
            :key="n"
            md="10"
            class="pa-1"
            style="cursor:pointer"
            @click="() => showImg(n)"
          >
            <v-card elevation="1" >
              <v-img
                :src="`${domoapi2_img}Articulo/${item.codigo}/Galeria?archivo=${item.archivo}&Cia=15`"
                :lazy-src="`${domoapi2_img}Articulo/${item.codigo}/Galeria?archivo=${item.archivo}&Cia=15`"
                contain
                aspect-ratio="1"
                class="mx-auto"
                max-width="100"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="secondary"
                      size="30"
                      width="2"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="loading">
        <Loading />
      </v-col>
    </v-row>
    <vue-easy-lightbox
      v-if="listimg.length !== 0"
      escEnabled
      moveEnabled
      :visible="visible"
      :imgs="apiImg"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import InnerImageZoom from "vue-inner-image-zoom";
import { mapState } from "vuex";
import { Loading } from "../LoadingDomo";
export default {
  components: {
    InnerImageZoom,
    Loading,
  },
  props: {
    codart: String,
  },
  created() {
    this.getImages();
  },
  data() {
    return {
      listimg: [],
      loading: false,
      visible: false,
      index: 0,
    };
  },
  computed: {
    ...mapState(["domoapi2_img"]),
    apiImg() {
      let data = [];
      let url = `${this.domoapi2_img}Articulo/${this.codart}/Galeria?archivo=`;
      if (this.listimg.length !== 0) {
        this.listimg.map((item) => {
          data.push(`${url}${item.archivo}`);
        });
      } else {
        data.push(`${this.domoapi2_img}Articulo/${this.codart}/Principal?cia=15`);
      }
      return data;
    },
    imagesPrincipal() {
      return this.listimg.filter((image) => {
        let number = image.archivo.split(".")[0];
        return number === "1";
      });
    },
    imagesLateral() {
      return this.listimg.filter((image) => {
        let number = image.archivo.split(".")[0];
        return number !== "1";
      });
    },
  },
  methods: {
    handleHide() {
      this.visible = false;
    },
    showImg(index) {
      this.index = index + 1;
      this.visible = true;
    },
    ChrEsp(chr) {
      const chrSplit = chr.split("");
      let newChr = "";

      chrSplit.forEach((x) => {
        if (x === "/") newChr += "-";
        else if (x === ".") newChr += "-";
        else newChr += x;
      });

      return newChr;
    },
    async dataFetch({ url, signal, method, data }) {
      const auth_token = localStorage.getItem("token");
      const headers = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        Authorization:
          auth_token && process.env.NODE_ENV !== "development"
            ? `Bearer ${auth_token}`
            : "",
      };
      const respuesta = await fetch(url, {
        method,
        signal,
        body: JSON.stringify(data),
        headers,
      });
      return respuesta;
    },
    async getImages() {
      const ImgAPI = `${this.domoapi2_img}Datos`;
      const params = {
        tipo: "Articulo",
        codigo: this.ChrEsp(this.codart),
        categoria: "Galeria",
        archivo: "",
      };
      const abortController = new AbortController();
      const { signal } = abortController;
      try {
        this.loading = true;
        const res = await this.dataFetch({
          url: ImgAPI,
          signal,
          method: "POST",
          data: params,
        });
        if (!res.ok) {
          const { statusText, type } = res;
          throw new Error(`Text: ${statusText} Type: ${type}`);
        }
        if (!signal.aborted) {
          const jsonData = await res.json();
          this.listimg = jsonData;
        }
      } catch (e) {
        if (!signal.aborted) console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.scrollable {
  max-height: 450px; /* Ajusta esto al alto máximo que desees */
  overflow-y: auto;
}
/* Estilo para Chrome, Edge y Safari */
.scrollable::-webkit-scrollbar {
  width: 5px; /* Ancho de la barra de desplazamiento */
}

.scrollable::-webkit-scrollbar-track {
  background: #d3bc8d; /* Color de la zona de desplazamiento */
}

.scrollable::-webkit-scrollbar-thumb {
  background-color: #7c2629; /* Color de la barra de desplazamiento */
  border-radius: 10px; /* Redondez de la barra de desplazamiento */
  border: 3px solid #7c2629; /* Crea un padding alrededor de la barra de desplazamiento */
}

/* Estilo para Firefox */
.scrollable {
  scrollbar-width: thin; /* "auto" o "thin" */
  scrollbar-color: #7c2629 #d3bc8d; /* color de la barra de desplazamiento y de la zona de desplazamiento */
}

</style>
